{
  "messages": {
    "rescheduledOnce": "เลื่อนนัดหนึ่งครั้ง",
    "rescheduledTwice": "เลื่อนนัดสองครั้ง",
    "rescheduledCountTimes": "เลื่อนนัด {count} ครั้ง"
  }
}
